<div class="container field-placement-editor">
    <lib-generic-dropdown
        [source]="source"
        [config]="{
            multiple: false,
            defaultText: 'Select ' + label,
            itemDisplayKey: 'name',
            clearSelection: false
        }"
        [(selectedItem)]="selectedItem"
        (selectedItemChange)="onSelectedItemChange()"
        [isReadOnly]="isReadOnly"
    >
    </lib-generic-dropdown>
</div>
